<div class="modal-header d-flex justify-content-between align-items-center">
  <h5 id="change-password-modal-title" class="m-0 fw-bold">Change Password</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="submit()" id="changePasswordForm" novalidate>
    <div class="card mb-3 border shadow-none">
      <div class="card-header">
        <h6 class="m-0 fw-semibold">Password Details</h6>
      </div>
      <div class="card-body">
        <p class="text-muted small mb-3">Choose a new password that’s hard to guess and unique to this account.</p>

        <div class="row g-3">
          <!-- Old Password -->
          <div class="col-12">
            <label class="form-label required mb-1" for="oldPassword">Old Password</label>
            <div class="position-relative">
              <input
                [type]="inputTypeOldPassword()"
                class="form-control"
                id="oldPassword"
                placeholder="Enter Old Password"
                formControlName="oldPassword"
                [class.is-invalid]="submitted() && controls.oldPassword.errors"
              />
              <span (click)="toggleOldPasswordVisibility()" class="eye-icon position-set-absolute">
                @if (inputTypeOldPassword() === 'password') {
                  <img src="/assets/icons/eye_off.svg" alt="Hide password" />
                } @else {
                  <img src="/assets/icons/eye.svg" alt="Show password" />
                }
              </span>
            </div>
            @if (submitted() && controls.oldPassword.errors?.['required']) {
              <div class="text-danger small mt-1">Old password is required.</div>
            }
          </div>

          <!-- New Password -->
          <div class="col-12">
            <label class="form-label required mb-1" for="newPassword">New Password</label>
            <div class="position-relative">
              <input
                [type]="inputTypeNewPassword()"
                class="form-control"
                id="newPassword"
                maxlength="50"
                placeholder="Enter New Password"
                formControlName="newPassword"
                [class.is-invalid]="submitted() && controls.newPassword.errors"
              />
              <span (click)="toggleNewPasswordVisibility()" class="eye-icon position-set-absolute">
                @if (inputTypeNewPassword() === 'password') {
                  <img src="/assets/icons/eye_off.svg" alt="Hide password" />
                } @else {
                  <img src="/assets/icons/eye.svg" alt="Show password" />
                }
              </span>
            </div>
            @if (submitted() && controls.newPassword.errors) {
              <div class="text-danger small mt-1">
                @if (controls.newPassword.errors['required']) {
                  New password is required.
                } @else if (controls.newPassword.errors['passwordRule']) {
                  {{ controls.newPassword.errors['passwordRule'] }}
                }
              </div>
            }
          </div>

          <!-- Confirm Password -->
          <div class="col-12">
            <label class="form-label required mb-1" for="confirmPassword">Confirm Password</label>
            <div class="position-relative">
              <input
                [type]="inputTypeConfirmPassword()"
                class="form-control"
                id="confirmPassword"
                maxlength="50"
                placeholder="Enter Confirm Password"
                formControlName="confirmPassword"
                [class.is-invalid]="submitted() && controls.confirmPassword.errors"
              />
              <span (click)="toggleConfirmPasswordVisibility()" class="eye-icon position-set-absolute">
                @if (inputTypeConfirmPassword() === 'password') {
                  <img src="/assets/icons/eye_off.svg" alt="Hide password" />
                } @else {
                  <img src="/assets/icons/eye.svg" alt="Show password" />
                }
              </span>
            </div>
            @if (submitted() && controls.confirmPassword.errors) {
              <div class="text-danger small mt-1">
                @if (controls.confirmPassword.errors['required']) {
                  Confirm password is required.
                } @else if (controls.confirmPassword.errors['mismatch']) {
                  New password and confirm password do not match.
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
  <button type="submit" form="changePasswordForm" class="btn btn-primary" [disabled]="loading()">
    {{ loading() ? 'Updating…' : 'Update' }}
  </button>
</div>
